import React from 'react';
import loadable from '@loadable/component';
import { func, shape } from 'prop-types';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "price-history" */ './product-price-history')
);

const ProductPriceHistory = props => <LoadableComponent {...props} />;

ProductPriceHistory.variables = ({ id, offset }) => ({
  id: parseInt(id, 10),
  offset: parseInt(offset, 10) || 0,
  statisticsTime: '1970-01-02',
});

ProductPriceHistory.loadOrder = [
  {
    priceHistory: true,
    priceHistoryTable: true,
  },
];

ProductPriceHistory.propTypes = {
  data: shape({
    product: {},
  }),
  fetchMoreData: func.isRequired,
};

ProductPriceHistory.defaultProps = {
  data: {
    product: undefined,
  },
};

export default ProductPriceHistory;
